import { jsx as _ } from "react/jsx-runtime";
import { c } from "../../../../clsx-OuTLNxxd.js";
const e = {
  "flex-children": "_flex-children_1c6gy_29",
  "justify-self-start": "_justify-self-start_1c6gy_29",
  "justify-self-end": "_justify-self-end_1c6gy_32",
  "justify-self-center": "_justify-self-center_1c6gy_35",
  "align-self-start": "_align-self-start_1c6gy_38",
  "align-self-end": "_align-self-end_1c6gy_41",
  "align-self-center": "_align-self-center_1c6gy_44",
  "dialog-overlay-show": "_dialog-overlay-show_1c6gy_1",
  "dialog-content-show": "_dialog-content-show_1c6gy_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1c6gy_1"
}, a = ({ alignSelf: s, justifySelf: l, children: t }) => {
  const n = c(
    e["flex-children"],
    s && e[`align-self-${s}`],
    l && e[`justify-self-${l}`]
  );
  return /* @__PURE__ */ _("div", { className: n, children: t });
};
export {
  a as FlexChildren
};
